module.exports = __webpack_public_path__ + "img/btn01.abcde20d.png";